export const sliderConstants = {
    SUCCESS: 'SLIDER_SUCCESS',
    ERROR: 'SLIDER_ERROR',
    FETCHING: 'SLIDER_FETCHING',
    PRINCIPAL_SUCCESS: 'SLIDER_PRINCIPAL_SUCCESS',
    SECONDARY_SUCCESS: 'SLIDER_SECONDARY_SUCCESS'
};
